import React,{Component,Fragment} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {listClinicData,Updateclinicentry,getFileFromServer,listSupportingDocuments,readtablesforpcl} from '../actions';
import Wrappercontainer from "../components/Wrappercontainer";
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import CsvDownload from 'react-json-to-csv';
import {
  Backdrop, Box, CircularProgress,
  Grid, Typography
} from "@material-ui/core";
import AppBarTop from "../components/AppBarTop";
import {Alert, AlertTitle} from "@material-ui/lab";
import {PURPLE_COLOR} from "../constants";
let exportBuffer = {};

//3 POSSIBLE STATES = PENDING/VERIFY/DONE
let PENDING_CASES_COUNTER = 0;
let DONE_CASES_COUNTER = 0;
let VERIFY_CASES_COUNTER = 0;
let TOTALCASES_COUNTER = 0;

class AdminView extends Component{
constructor(props) {
  super(props);
  this.state = {
    processedValues:[], clinicselection:'',loading:false,
    total:0,pending:0,verify:0,done:0
  };

}

componentDidMount() {
  window.scrollTo(0, 0);
  this.setState({loading:true});
  this.props.readtablesforpcl();
}

  handleClinicSelector(e){
  let clinic = e.target.value;
  this.setState({clinicselection:clinic})
    if(clinic!==""){
      this.props.listClinicData(clinic);
      this.setState({loading:true});
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.clinicdata){
      //List only OPD and EMG
      let newBuff = [];
      let pendingBuffer = [];
      let doneBuffer = [];
      nextProps.clinicdata.map((clinicitem,index)=>{
        if(clinicitem.TYPE == 'EMG' || clinicitem.TYPE == 'OPD'){
           newBuff.push(clinicitem);
        }
        if(clinicitem.PCLPROCESSING && clinicitem.PCLPROCESSING == 'DONE'){ doneBuffer.push(clinicitem);}
      })

      let calculatedValue = 0;
      calculatedValue = doneBuffer.length / newBuff.length
      calculatedValue = Math.round(calculatedValue * 100)

      this.setState({
        total:newBuff.length,
        done:doneBuffer.length,
        pending:newBuff.length - doneBuffer.length,
        percentageCompletion:calculatedValue,
        loading:false
      });
    }
    // if(nextProps.clinicdata){
    //   if(nextProps.clinicdata.clinicdata){
    //     let newBuffer = [];
    //     if(nextProps.clinicdata.clinicdata[0].clinicname=='darne'){
    //       TOTALCASES_COUNTER = TOTALCASES_COUNTER + nextProps.clinicdata.clinicdata.length;
    //       nextProps.clinicdata.clinicdata.map(item=>{
    //         let scaleofcost = "";
    //         let icdcode = "";
    //         if(item.scaleofcost){scaleofcost = item.scaleofcost;}
    //         if(item.icdcode){icdcode = item.icdcode;}
    //
    //         if(item.Reviewstatus == "PENDING"){PENDING_CASES_COUNTER ++;}
    //         if(item.Reviewstatus == "VERIFY"){VERIFY_CASES_COUNTER ++;}
    //         if(item.Reviewstatus == "DONE"){DONE_CASES_COUNTER ++;}
    //
    //         newBuffer.push({
    //           "Patient No.":item.UHID,
    //           "Bill Date":item.BillDate,
    //           "Clinic Name":item.clinicname,
    //           "IP No":item.IPNo,
    //           "Patient Name":item.PatientName,
    //           "Total Outstanding":item.TotalOutstanding,
    //           "Outstanding Doctor Allocation":item.OutstandingDoctorAllocation,
    //           "Outstanding Hospital Amount":item.OutstandingHospital,
    //           "Remarks":item.Comments,
    //           "Doctor Disallowed Amount":item.DoctorDisallowedAmount,
    //           "Status":item.Reviewstatus,
    //           "Scale Of Cost":scaleofcost,
    //           "ICD 10 Code":icdcode
    //         })
    //       });
    //       this.setState({loading:false,processedValues:newBuffer,
    //         total:TOTALCASES_COUNTER,verify:VERIFY_CASES_COUNTER,pending:PENDING_CASES_COUNTER,done:DONE_CASES_COUNTER});
    //       exportBuffer.darne = newBuffer;
    //     }
    //     if(nextProps.clinicdata.clinicdata[0].clinicname=='wellkin'){
    //       TOTALCASES_COUNTER = TOTALCASES_COUNTER + nextProps.clinicdata.clinicdata.length;
    //       nextProps.clinicdata.clinicdata.map(item=>{
    //         let scaleofcost = "";
    //         let icdcode = "";
    //         if(item.scaleofcost){scaleofcost = item.scaleofcost;}
    //         if(item.icdcode){icdcode = item.icdcode;}
    //
    //         if(item.Reviewstatus == "PENDING"){PENDING_CASES_COUNTER ++;}
    //         if(item.Reviewstatus == "VERIFY"){VERIFY_CASES_COUNTER ++;}
    //         if(item.Reviewstatus == "DONE"){DONE_CASES_COUNTER ++;}
    //
    //         newBuffer.push({
    //           "Patient No.":item.UHID,
    //           "Bill Date":item.BillDate,
    //           "Clinic Name":item.clinicname,
    //           "IP No":item.IPNo,
    //           "Patient Name":item.PatientName,
    //           "Total Outstanding":item.TotalOutstanding,
    //           "Outstanding Doctor Allocation":item.OutstandingDoctorAllocation,
    //           "Outstanding Hospital Amount":item.OutstandingHospital,
    //           "Remarks":item.Comments,
    //           "Doctor Disallowed Amount":item.DoctorDisallowedAmount,
    //           "Status":item.Reviewstatus,
    //           "Scale Of Cost":scaleofcost,
    //           "ICD 10 Code":icdcode
    //         })
    //       });
    //       exportBuffer.wellkin = newBuffer;
    //       if(exportBuffer.darne && exportBuffer.wellkin){ this.setState({loading:false,processedValues:newBuffer,
    //         total:TOTALCASES_COUNTER,verify:VERIFY_CASES_COUNTER,pending:PENDING_CASES_COUNTER,done:DONE_CASES_COUNTER});}
    //     }
    //   }
    // }

  }

  render() {

  console.log(this.state)


    return(
      <Fragment>
        <AppBarTop handleLogout={()=>this.props.history.push("/")}/>
        <Wrappercontainer large>
          <div style={{marginTop:75}}/>


          <Grid container={3}>

            <Grid item xs={12} md={6}>
              <Typography style={styles.adminPanelTextStyle}>admin panel</Typography>

              <Typography style={styles.adminPanelTextStyle}>PENDING : {this.state.pending} / {this.state.total}</Typography>

              <Typography style={styles.adminPanelTextStyle}>DONE : {this.state.done} / {this.state.total}</Typography>

              <Typography style={styles.adminPanelTextStyle}>TOTAL : {this.state.total} / {this.state.total}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box position="relative" display="inline-flex" style={{marginTop:35}}>
                <CircularProgress variant="determinate" size={100} value={this.state.percentageCompletion} />
                <Box
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  position="absolute"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography  variant="h5" component="div" color="textSecondary">{this.state.percentageCompletion} %</Typography>
                </Box>
              </Box>

              <Typography style={{marginTop:25}} variant="h5" component="div" color="textSecondary">% Completion</Typography>
            </Grid>



          </Grid>



          {/*<Grid container={3}>*/}
          {/*  <Grid xs/>*/}
          {/*  <Grid xs/>*/}
          {/*  <Grid xs>*/}
          {/*    <CsvDownload data={this.state.processedValues}*/}
          {/*                 style={styles.downloadButtonStyle}>*/}
          {/*      Click here to download data (darne only)</CsvDownload>*/}
          {/*  </Grid>*/}
          {/*</Grid>*/}


        </Wrappercontainer>
        <Backdrop style={{color:'#fff',zIndex:10000}} open={this.state.loading}>
          <Alert  severity={'info'}>
            <div style={{display:'flex',flexDirection:'row'}}>
              <AlertTitle>Please wait ...</AlertTitle>
              <CircularProgress style={{marginLeft:75}} size={20} color={'black'}/>
            </div>
            <strong>Data are being determined</strong>
          </Alert>
        </Backdrop>
      </Fragment>
    )
  }
}

const mapStateToProps = (data) => {
  return data;
}

export default connect(mapStateToProps,{listClinicData,Updateclinicentry,getFileFromServer,listSupportingDocuments,readtablesforpcl})(withRouter(AdminView));

const styles = {
  adminPanelTextStyle:{
    color:PURPLE_COLOR,
    fontWeight:'bold',
    textTransform: 'uppercase',
    fontSize:20,
    padding:20
  },
  downloadButtonStyle: {
    marginTop:25,
    marginBottom:25,
    backgroundColor:'white',
    fontWeight:'bold',
    textTransform:'uppercase',
    padding:10,
    color:PURPLE_COLOR,
    borderRadius:5,
    cursor:'pointer'
  }
}
